import React from 'react';
import { ProgramList } from 'components';

const PageCatalog = () => (
  <ProgramList />
);

export default PageCatalog;